







import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import Company from "../../models/company/Company";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import BillList from "@/components/bill/BillList.vue";

@Component({
	components: {BillList, AsiContentContainer}
})
export default class CompanyTabBills extends Vue {

	@Prop({type: Object, required: true})
	public company!: Company;

}
